import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

// Get Logs
export const getLogs = async (d_id) => {
  const token = sessionStorage.getItem('authToken');
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${d_id}/getLogs`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    }); 

    if (!response.ok) {
      throw new Error('Failed to fetch user logs');
    }

    const logs = await response.json();
    return logs;
  } catch (error) {
    console.error('Error fetching user logs:', error);
    throw error;
  }
};